export default __webpack_public_path__ + "static/media/slots_img_mobile.7448d7d0.png";